import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import styles from 'styles/jss/original/components/shoppings/shoppingMenuTab';
import ShoppingList from '@/components/shoppings/ShoppingList';
import NavPills from '@/components/common/ui/NavPills';
import { IShopping } from '@/@types/generated/contentful';

const useStyles = makeStyles(styles);

type ComponentProps = {
  shoppingList: IShopping[];
  categoryList: string[];
};

const ShoppingMenuTab: React.FC<ComponentProps> = ({ shoppingList, categoryList }) => {
  const classes = useStyles();
  const tabsProps = categoryList.reduce(
    (arr, item) => {
      const shoppingCategoryList = shoppingList.filter((i) => i.fields.cat === item);
      return [
        ...arr,
        {
          tabButton: item,
          tabContent: <ShoppingList shoppingList={shoppingCategoryList} />
        }
      ];
    },
    [
      {
        tabButton: 'すべて',
        tabContent: <ShoppingList shoppingList={shoppingList} />
      }
    ]
  );
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer>
          {/* @ts-expect-error */}
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <NavPills color='warning' tabs={tabsProps} isShopping />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default ShoppingMenuTab;
